/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/prop-types */
import { useState } from "react";
import {
  CFormInput,
  CFormLabel,
  CInputGroup,
  CInputGroupText,
} from "@coreui/react-pro";
import { getIn } from "formik";
import CIcon from "@coreui/icons-react";
import { cilEyedropper, cilFindInPage, cilLowVision } from "@coreui/icons";

const PasswordField = ({
  formik,
  label,
  name,
  placeholder = "",
  required = false,
  isDisabled = false,
  value,
  handleChange,
  labelClass,
  inputClass,
  parentClass,
  prefix,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const fieldValue = value ?? (formik ? getIn(formik.values, name) || "" : "");
  const fieldError =
    formik && getIn(formik.touched, name) && getIn(formik.errors, name)
      ? getIn(formik.errors, name)
      : null;

  const inputClassName = `form-control ${inputClass || ""} ${
    fieldError ? "is-invalid" : ""
  }`;

  const onChangeHandler = (e) => {
    const val = e.target.value;
    if (formik) {
      formik.setFieldValue(name, val);
    } else if (handleChange) {
      handleChange(val);
    }
  };

  const inputField = (
    <CFormInput
      id={name}
      name={name}
      type={showPassword ? "text" : "password"}
      placeholder={placeholder}
      disabled={isDisabled}
      value={fieldValue}
      className={inputClassName}
      onChange={onChangeHandler}
      onBlur={formik ? formik.handleBlur : undefined}
    />
  );

  return (
    <div className={`mb-3 ${parentClass || ""}`}>
      {label && (
        <div>
          <CFormLabel htmlFor={name} className={labelClass}>
            {label}
          </CFormLabel>
          {required && <CFormLabel className="text-danger">*</CFormLabel>}
        </div>
      )}

      <CInputGroup>
        {prefix && <CInputGroupText>{prefix}</CInputGroupText>}

        {inputField}

        {/* show/hide password button */}
        <CInputGroupText
          role="button"
          onClick={() => setShowPassword((prev) => !prev)}
          style={{ cursor: "pointer" }}
        >
          <CIcon icon={showPassword ? cilFindInPage : cilLowVision} />
        </CInputGroupText>
      </CInputGroup>

      {fieldError && (
        <div className="invalid-feedback d-block">{fieldError}</div>
      )}
    </div>
  );
};

export default PasswordField;
